import type { DemoDomain, DemoDomainLog, DemoEvidenceExport, DemoOwaspCategory } from './demoFixtures';
import { buildDemoDomains, buildDemoEvidenceExport, buildDemoLogs } from './demoFixtures';

const demoDomains = buildDemoDomains();
const demoLogsBySite = new Map<string, DemoDomainLog[]>();

demoDomains.forEach((domain) => {
  demoLogsBySite.set(domain.site_id, buildDemoLogs(domain));
});

export type DemoDataProvider = {
  listDomains: () => Promise<DemoDomain[]>;
  getDomain: (siteId: string) => Promise<DemoDomain | null>;
  getOwaspStatus: (siteId: string) => Promise<DemoOwaspCategory[]>;
  getDomainLogs: (siteId: string) => Promise<DemoDomainLog[]>;
  exportEvidence: (siteId: string, enforcementState: Record<string, boolean>, policyTier: DemoDomain['policy_tier']) => Promise<DemoEvidenceExport | null>;
};

export const demoDataProvider: DemoDataProvider = {
  listDomains: async () => demoDomains,
  getDomain: async (siteId: string) => demoDomains.find((domain) => domain.site_id === siteId) ?? null,
  getOwaspStatus: async (siteId: string) => demoDomains.find((domain) => domain.site_id === siteId)?.owasp ?? [],
  getDomainLogs: async (siteId: string) => demoLogsBySite.get(siteId) ?? [],
  exportEvidence: async (siteId: string, enforcementState, policyTier) => {
    const domain = demoDomains.find((item) => item.site_id === siteId);
    if (!domain) return null;
    const logs = demoLogsBySite.get(siteId) ?? [];
    return buildDemoEvidenceExport(domain, logs, enforcementState, policyTier);
  },
};
